var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"deck"},_vm._l((_vm.decks.get(_vm.selectedDeck)),function(value){return _c('SmallCard',{key:value,attrs:{"cardValue":value}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }